import { useState, useEffect, useCallback } from 'react';
import { usersApi, battlesApi } from '../lib/api';
import { toast } from 'sonner';

/**
 * useFansData — fetches leaderboard + (if authenticated) user's battle history.
 * Exposes update helpers for follow toggle.
 */
export function useFansData(user) {
  const [leaderboard, setLeaderboard] = useState([]);
  const [battles, setBattles] = useState([]);
  const [loadingLb, setLoadingLb] = useState(true);
  const [loadingB, setLoadingB] = useState(true);

  useEffect(() => {
    let active = true;
    usersApi.leaderboard(20)
      .then((data) => { if (active) setLeaderboard(data); })
      .catch(() => { if (active) toast.error('Classement indisponible'); })
      .finally(() => { if (active) setLoadingLb(false); });

    if (user) {
      battlesApi.myHistory(20)
        .then((data) => { if (active) setBattles(data); })
        .catch(() => {})
        .finally(() => { if (active) setLoadingB(false); });
    } else {
      setLoadingB(false);
    }
    return () => { active = false; };
  }, [user]);

  const bumpFanCount = useCallback((targetId, delta) => {
    setLeaderboard((prev) => prev.map((u) => (u.id === targetId ? { ...u, fans: u.fans + delta } : u)));
  }, []);

  return { leaderboard, battles, loadingLb, loadingB, bumpFanCount };
}
